export function isSlideAutoHeight({
  type,
  contentTitleEnabled,
  contentTextEnabled,
  contentButtonEnabled,
  contentBadgeEnabled,
  contentMediaEnabled,
  contentMedia
} = {}) {
  if (type) {
    return type === 'image-slide' || type === 'video-slide';
  }

  return (
    !contentTitleEnabled &&
    !contentTextEnabled &&
    !contentButtonEnabled &&
    !contentBadgeEnabled &&
    !contentMediaEnabled &&
    !(contentMedia && contentMediaEnabled)
  );
}
